// /* eslint-disable react-hooks/exhaustive-deps */
// /* eslint-disable jsx-a11y/alt-text */
// import React, { useEffect, useState } from "react";
// import { IconDownload, IconEye } from "@tabler/icons-react";
// import ColumnsFilter from "../../../components/common/ColumnsFilter";
// import CommonModal from "../../../components/common/CommonModal";
// import DropdownFilter from "../../../components/common/DropdownFilter";
// import ListView from "../../../components/common/ListView";
// import NormalSearch from "../../../components/common/NormalSearch";
// import { useOdometerListData } from "../../../apis/fleetApis";
// import formatDate from "../../../utilities/helper";
// import NoDataFound from "../../../components/common/NoDataFound";
// import TableSkeleton from "../../../components/skeleton/TableSkeleton";
// import useDebounce from "../../../utilities/useDebounce";
// import Pagination from "../../../components/common/Pagination";
// import EntriesSelector from "../../../components/common/EntriesSelector";
// import { useSelector } from "react-redux";
// import { handleDownload } from "../../../utilities/downloadHelper";

// type OdometerData = {
//   id: string;
// };

// interface OdometerRecord {
//   driver_code: string;
//   start_km: string;
//   end_km: string;
//   start_km_image: string;
//   end_km_image: string;
//   created_at: string;
// }

// const Odometer: React.FC = () => {
//   const [pageNo, setPageNo] = useState<number>(1);
//   const [limit, setLimit] = useState<number>(10);
//   const [searchFor, setSearchFor] = useState<string>("");
//   const [selectedRows, setSelectedRows] = useState<string[]>([]);
//   const [allSelectedData, setAllSelectedData] = useState<OdometerData[]>([]);
//   const [showCheckboxes, setShowCheckboxes] = useState<boolean>(false);

//   const { isLoading, refetch, isFetching } = useOdometerListData(
//     pageNo,
//     limit,
//     searchFor
//   );

//   const data = useSelector((state: any) => state?.odometer?.data);

//   const handlePaginationFetch = (page: number) => {
//     setPageNo(page);
//   };

//   useEffect(() => {
//     if (data?.odometers) {
//       setAllSelectedData((prev) => {
//         const filteredPrev = prev.filter((item: any) =>
//           selectedRows.includes(item.id)
//         );
//         const newSelected = data.odometers.filter(
//           (s: any) =>
//             selectedRows.includes(s.id) &&
//             !filteredPrev.some((item) => item.id === s.id)
//         );
//         return [...filteredPrev, ...newSelected];
//       });
//     }
//   }, [data?.odometers, selectedRows]);

//   const debouncedSearchFor = useDebounce(searchFor, 550);

//   useEffect(() => {
//     refetch();
//   }, [debouncedSearchFor, pageNo, limit]);

//   const [openOdoMeter, setOpenOdoMeter] = useState<boolean>(false);
//   const [openImage, setOpenImage] = useState<any>();

//   const openOdoMeterToggleModal = (image: string = "") => {
//     setOpenOdoMeter(!openOdoMeter);
//     setOpenImage(image);
//   };

//   const handleDownloadImage = () => {
//     const a = document.createElement("a");
//     a.href = openImage;
//     a.download = "odometer-image.jpg";
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//   };

//   // 🔹 Columns state for dynamic show/hide
//   const [columnsData, setColumnsData] = useState([
//     { text: "Checkbox", value: "checkbox", isShow: showCheckboxes },
//     { text: "S/N", value: "sn", isShow: true },
//     { text: "Driver Id", value: "driver_code", isShow: true },
//     { text: "Start km", value: "start_km", isShow: true },
//     { text: "End km", value: "end_km", isShow: true },
//     { text: "Total", value: "total", isShow: true },
//     { text: "Date", value: "created_at", isShow: true },
//     { text: "Actions", value: "actions", isShow: true },
//   ]);

//   const setHeadings = (value: string | undefined, checked: boolean) => {
//     setColumnsData((prev) =>
//       prev.map((col) =>
//         col.value === value ? { ...col, isShow: checked } : col
//       )
//     );
//   };

//   // 🔹 Build dynamic columns
//   const handleSelectRow = (id: string) => {
//     setSelectedRows((prev) =>
//       prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
//     );
//   };

//   const handleSelectAll = () => {
//     if (selectedRows.length === data?.odometers?.length) {
//       setSelectedRows((prev) =>
//         prev.filter((id) => !data.odometers.some((c: any) => c.id === id))
//       );
//     } else {
//       const newSelections =
//         data?.odometers
//           ?.filter((c: any) => !selectedRows.includes(c.id))
//           .map((c: any) => c.id) || [];
//       setSelectedRows((prev) => [...prev, ...newSelections]);
//     }
//   };

//   const columns = columnsData
//     .filter((c) => c.isShow)
//     .map((col) => {
//       switch (col.value) {
//         case "checkbox":
//           return {
//             label: (
//               <label className="relative flex items-center cursor-pointer">
//                 <input
//                   type="checkbox"
//                   checked={
//                     data?.odometers?.length > 0 &&
//                     data?.odometers?.every((c: any) =>
//                       selectedRows.includes(c.id)
//                     )
//                   }
//                   onChange={handleSelectAll}
//                   className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037]
//                  bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
//                 />
//                 <span
//                   className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0
//                   top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
//                 >
//                   ✓
//                 </span>
//               </label>
//             ),
//             render: (c: any) => (
//               <label className="relative flex items-center cursor-pointer">
//                 <input
//                   type="checkbox"
//                   checked={selectedRows.includes(c.id)}
//                   onChange={() => handleSelectRow(c.id)}
//                   className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037]
//                   bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
//                 />
//                 <span
//                   className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0
//                                 top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
//                 >
//                   ✓
//                 </span>
//               </label>
//             ),
//           };
//         case "sn":
//           return {
//             label: "#",
//             render: (_: OdometerRecord, i: number) =>
//               (pageNo - 1) * limit + (i + 1),
//           };
//         case "driver_code":
//           return {
//             label: "Driver Id",
//             render: (record: OdometerRecord) => record.driver_code,
//           };
//         case "start_km":
//           return {
//             label: "Start km",
//             render: (record: OdometerRecord) => record.start_km,
//           };
//         case "end_km":
//           return {
//             label: "End km",
//             render: (record: OdometerRecord) => record.end_km,
//           };
//         case "total":
//           return {
//             label: "Total",
//             render: (record: OdometerRecord) =>
//               parseInt(record.end_km) - parseInt(record.start_km),
//           };
//         case "created_at":
//           return {
//             label: "Date",
//             render: (record: OdometerRecord) => formatDate(record.created_at),
//           };
//         case "actions":
//           return {
//             label: "Action",
//             render: (record: OdometerRecord) => (
//               <div className="text-center">
//                 <button
//                   onClick={() => openOdoMeterToggleModal(record.start_km_image)}
//                   className="p-2 border rounded-full bg-[#F7F6F2]"
//                 >
//                   <IconEye size={22} />
//                 </button>
//               </div>
//             ),
//           };
//         default:
//           return { label: "", render: () => null };
//       }
//     });

//   const mapDataToExport = (c: any, index: number) => ({
//     "S/N": index + 1,
//     "Driver Id": c.driver_code,
//     "Start km": c.start_km,
//     "End km": c.end_km,
//     Total: parseInt(c.end_km) - parseInt(c.start_km),
//     Date: formatDate(c.created_at),
//   });

//   return (
//     <>
//       <div>
//         <div className="flex items-center">
//           <div className=" bg-[#F7F6F2] flex items-center justify-between px-6 py-3 w-full rounded-tl-3xl rounded-tr-[40px] ">
//             <h1 className="text-xl text-[#212121] tracking-[-0.5px] font-medium">
//               Odometer History
//             </h1>
//             <div className="flex items-center gap-2">
//               {data && data.totalPages * limit > 10 && (
//                 <EntriesSelector
//                   value={limit}
//                   options={[
//                     10,
//                     ...(data.totalPages * limit > 10 ? [20] : []),
//                     ...(data.totalPages * limit > 20 ? [30] : []),
//                     ...(data.totalPages * limit > 50 ? [50] : []),
//                     ...(data.totalPages * limit > 100 ? [100] : []),
//                   ]}
//                   onChange={(val) => {
//                     setLimit(val);
//                     setPageNo(1);
//                   }}
//                 />
//               )}
//               <ColumnsFilter
//                 columnsData={columnsData.filter((c) => c.value !== "checkbox")}
//                 setHeadings={setHeadings}
//               />
//               <DropdownFilter filterheadings={[]} />
//               <NormalSearch
//                 value={searchFor}
//                 onChange={(e) => {
//                   setSearchFor(e.target.value);
//                   setPageNo(1);
//                 }}
//               />
//             </div>
//           </div>
//           <div className="relative ml-5">
//             <div className=" flex items-center gap-2 justify-end rounded-full">
//               <button
//                 onClick={() =>
//                   handleDownload({
//                     selectedRows,
//                     allSelectedData,
//                     setSelectedRows,
//                     setAllSelectedData,
//                     showCheckboxes,
//                     setShowCheckboxes,
//                     setColumnsData,
//                     mapDataToExport,
//                     fileName: "odometer_history.xlsx",
//                   })
//                 }
//                 className={`flex items-center gap-1 p-2.5 text-sm rounded-full border border-[#FFFFFF] ${
//                   showCheckboxes && selectedRows.length === 0
//                     ? "bg-[#F7F6F2]/50 text-[#404040]/50"
//                     : "bg-[#F7F6F2] text-[#404040]"
//                 }`}
//               >
//                 <IconDownload stroke={1.5} size={24} />
//                 {selectedRows.length > 0 && (
//                   <span>({selectedRows.length})</span>
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>

//         <div>
//           {isLoading || isFetching ? (
//             <TableSkeleton
//               columns={columnsData.filter((c) => c.isShow).map((c) => c.text)}
//               rows={6}
//             />
//           ) : data?.odometers && data.odometers.length > 0 ? (
//             <ListView
//               data={data?.odometers ?? []}
//               onRowClick={(client: OdometerRecord) =>
//                 console.log("Clicked:", client)
//               }
//               columns={columns}
//             />
//           ) : (
//             <NoDataFound />
//           )}
//         </div>
//         <div className="py-4 flex justify-center">
//           {data?.totalPages > 1 && (
//             <Pagination
//               totalPages={data?.totalPages}
//               currentPage={pageNo}
//               fetchData={handlePaginationFetch}
//             />
//           )}
//         </div>
//       </div>

//       <CommonModal
//         title={"Meter Preview"}
//         open={openOdoMeter}
//         closeButtonText={"Cancel"}
//         onClose={() => {
//           openOdoMeterToggleModal();
//         }}
//         actionButtonText="Download"
//         actionButtonOnClick={handleDownloadImage}
//         actionButtonIcon={<IconDownload stroke={1.5} size={20} />}
//       >
//         <div className="w-full py-4 px-6 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
//           <div className="w-[555px]">
//             <img
//               src={openImage}
//               alt=""
//               className="w-full mx-auto rounded h-[400px] object-cover"
//             />
//           </div>
//         </div>
//       </CommonModal>
//     </>
//   );
// };

// export default Odometer;

/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import { IconDownload, IconEye, IconDashboard } from "@tabler/icons-react";
import ColumnsFilter from "../../../components/common/ColumnsFilter";
import CommonModal from "../../../components/common/CommonModal";
import DropdownFilter from "../../../components/common/DropdownFilter";
import ListView from "../../../components/common/ListView";
import NormalSearch from "../../../components/common/NormalSearch";
import { T, useLanguage } from "../../../context/LanguageContext";
import { useOdometerListData } from "../../../apis/fleetApis";
import formatDate from "../../../utilities/helper";
import NoDataFound from "../../../components/common/NoDataFound";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";
import useDebounce from "../../../utilities/useDebounce";
import Pagination from "../../../components/common/Pagination";
import EntriesSelector from "../../../components/common/EntriesSelector";
import { useSelector } from "react-redux";
import { handleDownload } from "../../../utilities/downloadHelper";
import RoleToggle from "../../../components/RoleToggle";
import CardSkeleton from "../../../components/skeleton/CardSkeleton";

type OdometerData = {
  id: string;
};

interface OdometerRecord {
  driver_code: string;
  start_km: string;
  end_km: string;
  start_km_image: string;
  end_km_image: string;
  created_at: string;
}

const roles = ["Start", "End"];

interface OdometerProps {
  vehicleId?: string;
}

const Odometer: React.FC<OdometerProps> = ({ vehicleId }) => {
  const { t } = useLanguage();
  const [pageNo, setPageNo] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [searchFor, setSearchFor] = useState<string>("");
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [allSelectedData, setAllSelectedData] = useState<OdometerData[]>([]);
  const [showCheckboxes, setShowCheckboxes] = useState<boolean>(false);

  const { isLoading, refetch, isFetching } = useOdometerListData(
    pageNo,
    limit,
    searchFor,
    vehicleId
  );

  const data = useSelector((state: any) => state?.odometer?.data);

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };

  useEffect(() => {
    if (data?.odometers) {
      setAllSelectedData((prev) => {
        const filteredPrev = prev.filter((item: any) =>
          selectedRows.includes(item.id)
        );
        const newSelected = data.odometers.filter(
          (s: any) =>
            selectedRows.includes(s.id) &&
            !filteredPrev.some((item) => item.id === s.id)
        );
        return [...filteredPrev, ...newSelected];
      });
    }
  }, [selectedRows, data?.odometers]);

  const debouncedSearchFor = useDebounce(searchFor, 550);

  useEffect(() => {
    refetch();
  }, [debouncedSearchFor, pageNo, limit, vehicleId]);

  const [openOdoMeter, setOpenOdoMeter] = useState<boolean>(false);
  const [openImage, setOpenImage] = useState<string>("");
  const [selectedRecord, setSelectedRecord] = useState<OdometerRecord | null>(
    null,
  );
  const [activeRole, setActiveRole] = useState<string>("Start");

  const openOdoMeterToggleModal = () => {
    setOpenOdoMeter((prev) => !prev);
  };

  const handlePreviewClick = (record: OdometerRecord) => {
    setSelectedRecord(record);
    setActiveRole("Start"); // default
    setOpenImage(record.start_km_image);
    setOpenOdoMeter(true);
  };

  const handleRoleChange = (role: string) => {
    setActiveRole(role);

    if (!selectedRecord) return;

    if (role === "Start") {
      setOpenImage(selectedRecord.start_km_image);
    } else {
      setOpenImage(selectedRecord.end_km_image);
    }
  };

  const handleDownloadImage = () => {
    const a = document.createElement("a");
    a.href = openImage;
    a.target = "_blank";
    a.download = "odometer-image.jpg";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const [columnsData, setColumnsData] = useState([
    { text: "Checkbox", value: "checkbox", isShow: showCheckboxes },
    { text: "S/N", value: "sn", isShow: true },
    { text: "Driver Id", value: "driver_code", isShow: true },
    { text: "Start km", value: "start_km", isShow: true },
    { text: "End km", value: "end_km", isShow: true },
    { text: "Total", value: "total", isShow: true },
    { text: "Date", value: "created_at", isShow: true },
    { text: "Actions", value: "actions", isShow: true },
  ]);

  const setHeadings = (value: string | undefined, checked: boolean) => {
    setColumnsData((prev) =>
      prev.map((col) =>
        col.value === value ? { ...col, isShow: checked } : col,
      ),
    );
  };

  const handleSelectRow = (id: string) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id],
    );
  };

  const handleSelectAll = () => {
    if (selectedRows.length === data?.odometers?.length) {
      setSelectedRows((prev) =>
        prev.filter((id) => !data.odometers.some((c: any) => c.id === id)),
      );
    } else {
      const newSelections =
        data?.odometers
          ?.filter((c: any) => !selectedRows.includes(c.id))
          .map((c: any) => c.id) || [];
      setSelectedRows((prev) => [...prev, ...newSelections]);
    }
  };

  const columns = columnsData
    .filter((c) => c.isShow)
    .map((col) => {
      switch (col.value) {
        case "checkbox":
          return {
            label: (
              <label className="relative flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={
                    data?.odometers?.length > 0 &&
                    data?.odometers?.every((c: any) =>
                      selectedRows.includes(c.id),
                    )
                  }
                  onChange={handleSelectAll}
                  className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] 
                  bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
                />
                <span
                  className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 
                  top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                >
                  ✓
                </span>
              </label>
            ),
            render: (c: any) => (
              <label className="relative flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={selectedRows.includes(c.id)}
                  onChange={() => handleSelectRow(c.id)}
                  className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] 
                  bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
                />
                <span
                  className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 
                  top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                >
                  ✓
                </span>
              </label>
            ),
          };

        case "sn":
          return {
            label: "S/N",
            render: (_: OdometerRecord, i: number) =>
              (pageNo - 1) * limit + (i + 1),
          };

        case "driver_code":
          return {
            label: "Driver Id",
            render: (record: OdometerRecord) => record.driver_code,
          };

        case "start_km":
          return {
            label: "Start km",
            render: (record: OdometerRecord) => record.start_km,
          };

        case "end_km":
          return {
            label: "End km",
            render: (record: OdometerRecord) => record.end_km,
          };

        case "total":
          return {
            label: "Total",
            render: (record: OdometerRecord) =>
              parseInt(record.end_km) - parseInt(record.start_km),
          };

        case "created_at":
          return {
            label: "Date",
            render: (record: OdometerRecord) => formatDate(record.created_at),
          };

        case "actions":
          return {
            label: "Action",
            render: (record: OdometerRecord) => (
              <div className="text-center">
                <button
                  onClick={() => handlePreviewClick(record)}
                  className="p-2 border rounded-full bg-[#F7F6F2]"
                >
                  <IconEye size={22} />
                </button>
              </div>
            ),
          };

        default:
          return { label: "", render: () => null };
      }
    });

  const mapDataToExport = (c: any, index: number) => ({
    "S/N": index + 1,
    "Driver Id": c.driver_code,
    "Start km": c.start_km,
    "End km": c.end_km,
    Total: parseInt(c.end_km) - parseInt(c.start_km),
    Date: formatDate(c.created_at),
  });

  if (selectedRecord && openOdoMeter) {
    return (
      <div className="space-y-4 p-2">
        {/* Back Header */}
        <div className="flex items-center justify-between pb-2 border-b border-gray-100">
          <button
            onClick={() => {
              setOpenOdoMeter(false);
              setSelectedRecord(null);
            }}
            className="flex items-center gap-1.5 text-sm font-semibold text-slate-600 hover:text-[#212121] transition-colors"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="tabler-icon tabler-icon-arrow-left"
            >
              <path d="M5 12l14 0"></path>
              <path d="M5 12l6 6"></path>
              <path d="M5 12l6 -6"></path>
            </svg>
            <T>Back to Odometer</T>
          </button>
          
          <button
            onClick={handleDownloadImage}
            className="flex items-center gap-1.5 px-3 py-1.5 bg-[#FBD037]/20 text-[#000000] hover:bg-[#FBD037]/30 text-xs font-semibold rounded-lg transition-colors border border-[#FBD037]/30"
          >
            <IconDownload size={14} />
            <T>Download</T>
          </button>
        </div>

        {/* Toggle between Start and End image */}
        <div className="flex justify-center">
          <RoleToggle
            options={roles}
            active={activeRole}
            onChange={handleRoleChange}
          />
        </div>

        {/* Image Preview */}
        <div className="group rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 overflow-hidden shadow-sm flex items-center justify-center relative">
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
          {openImage ? (
            <img
              src={openImage}
              alt={`${activeRole} KM Preview`}
              className="w-full rounded-2xl h-[300px] object-cover"
            />
          ) : (
            <div className="text-gray-400 flex flex-col items-center py-12">
              <IconDashboard size={48} className="mb-2 opacity-50" />
              <span><T>No image available</T></span>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <>
      <div>
        <div className="flex items-center justify-between px-2 py-4 w-full">
          <div className="flex items-center gap-3">
            <h1 className="text-xl text-[#212121] tracking-[-0.5px] font-medium">
              <T>Odometer</T>
            </h1>
          </div>
          {data?.odometers && (
            <div className="flex items-center">
              <span className="bg-gray-200 text-gray-700 text-xs font-semibold px-2.5 py-1.5 rounded-md">
                <T>Total logs</T>:{" "}
                {data.totalPages * limit > data.odometers.length
                  ? data.totalPages * limit
                  : data.odometers.length}
              </span>
            </div>
          )}
        </div>

        {/* LIST VIEW */}
        <div>
          {isLoading || isFetching ? (
            <CardSkeleton rows={3} />
          ) : data?.odometers && data.odometers.length > 0 ? (
            <div className="flex flex-col">
              <div className="group rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 overflow-hidden shadow-sm relative">
                <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
                {data.odometers.map((record: any, idx: number) => (
                  <div
                    key={record.id || idx}
                    className="flex flex-col sm:flex-row sm:items-center justify-between p-4 sm:p-5 border-b border-gray-100 last:border-b-0 gap-3 hover:bg-gray-50 transition-colors group cursor-pointer"
                    onClick={() => handlePreviewClick(record)}
                  >
                    <div className="flex items-center gap-4">
                      <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-[#FBD037]/10 flex items-center justify-center border border-[#FBD037]/20 text-[#212121] group-hover:bg-[#FBD037] transition-colors shrink-0">
                        <IconDashboard size={20} className="sm:hidden" />
                        <IconDashboard size={24} className="hidden sm:block" />
                      </div>
                      <div className="min-w-0">
                        <div className="flex flex-wrap items-center gap-x-2 gap-y-1 mb-0.5">
                          <h3 className="text-[#212121] font-bold text-base sm:text-lg truncate max-w-[120px] sm:max-w-xs">
                            {record.vehicle_name ||
                              record.vehicles_name ||
                              t("Vehicle")}
                          </h3>
                          <span className="text-gray-500 font-mono text-[10px] sm:text-xs tracking-wide bg-gray-100 px-1.5 py-0.5 rounded">
                            {record.vehicle_number ||
                              record.vehicles_number ||
                              "V-000"}
                          </span>
                        </div>
                        <p className="text-gray-500 text-xs sm:text-sm truncate max-w-[200px] sm:max-w-xs">
                          <T>Reported by</T>{" "}
                          <span className="font-semibold text-gray-700">
                            {record.driver_name ||
                              record.driver_code ||
                              "Unknown"}
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="text-left sm:text-right border-t sm:border-t-0 border-gray-100 pt-2 sm:pt-0 shrink-0 flex sm:flex-col justify-between items-center sm:items-end">
                      <p className="text-xl sm:text-2xl font-bold text-[#212121] tracking-tight">
                        {Number(record.end_km).toLocaleString()}{" "}
                        <span className="text-xs sm:text-sm text-gray-500 font-medium ml-1">
                          {t("km")}
                        </span>
                      </p>
                      <p className="text-gray-400 text-xs sm:text-sm">
                        {formatDate(record.created_at)}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <NoDataFound />
          )}
        </div>
        {/* PAGINATION */}
        <div className="py-4 flex justify-center">
          {data?.totalPages > 1 && (
            <Pagination
              totalPages={data?.totalPages}
              currentPage={pageNo}
              fetchData={handlePaginationFetch}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Odometer;
